import { formatISO, subHours } from 'date-fns'
import { useGetRatesBatch } from '~api'

export const usePrevCurrentRatesBatch = ({
    quote,
    currencies,
    isNewRateService,
}: {
    quote: string
    currencies: string[]
    isNewRateService: boolean | undefined
}) => {
    const timestamp24h = formatISO(subHours(new Date(), 24), { representation: 'complete' })

    const { data: prevRatesData, isLoading: isPrevRatesLoading } = useGetRatesBatch({
        shouldRequest: isNewRateService && Boolean(currencies.length),
        key: 'prev' + quote,
        params: {
            items: [
                {
                    quote,
                    base: currencies,
                    timestamp: timestamp24h,
                },
            ],
        },
    })

    const { data: ratesData, isLoading: isRatesLoading } = useGetRatesBatch({
        shouldRequest: isNewRateService && Boolean(currencies.length),
        key: quote,
        params: {
            items: [
                {
                    quote,
                    base: currencies,
                },
            ],
        },
    })

    return { ratesData, prevRatesData, isLoading: isRatesLoading || isPrevRatesLoading }
}
